import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from "react-select";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { toastAlert } from '../../../lib/toastAlert';
import config from '../../../lib/config'

const PayModal = (props) => {
    const {PlanShowTable, Wallet_Details, App_Btn, SetApp_Btn, DBsavePackBuy, SetTransCation} = props

    const [showModel, setShowModel] = useState(true)

    return (
        <div className='modals'>
            <Modal
                onHide={() => { props.onDismiss() }}
                show={showModel}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header closeButton onClick={() => props.onDismiss()}>
                    <Modal.Title>CheckOut</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <div className="">
                    <div className="row mx-0">
                    <div className="col-12 col-md-6 px-4">
                        <p className="buy_title_sm text-md-right">User Address</p>
                        <p className="buy_title_md text-md-right">{(PlanShowTable?.Address)?.slice(0, 20)}</p>
                    </div>
                    </div>
                    <div className="row mx-0 pb-3">
                    <div className="col-12 col-sm-6 px-4">
                        <p className="buy_desc_sm">Price of the NFT</p>
                    </div>
                    <div className="col-12 col-sm-6 px-4 text-sm-right">
                        <p className="buy_desc_sm_bold">{PlanShowTable?.ClaimAmount} {"Fait"}</p>
                    </div>
                    </div>
                    <PayPalScriptProvider options={{
                    "client-id": config.PayPalKey
                    }}>
                    <PayPalButtons
                        style={{ layout: "vertical" }}
                        disabled={App_Btn == "Done" ? true : false}
                        forceReRender={[PlanShowTable]}

                        createOrder={(data, actions) => {
                        SetApp_Btn("process")
                        return actions.order
                            .create({
                            purchase_units: [
                                {
                                amount: {
                                    currency_code: "USD",
                                    value: PlanShowTable?.ClaimAmount,
                                },
                                payee: {
                                    email_address: PlanShowTable?.paypalId,
                                },

                                },
                            ],
                            })
                            .then((orderId) => {
                            return orderId;
                            });
                        }}
                        onApprove={(data, actions) => {
                        return actions.order.capture().then((details) => {
                            const Data = {
                            Buyername: details.payer.name.given_name,
                            Surname: details.payer.name.surname,
                            id: details.purchase_units[0].payments.captures[0].id,
                            TranscationId: details.id,
                            email_address: details.payer.email_address,
                            payer_id: details.payer.payer_id,
                            status: details.status,
                            Address: details.payer.address.country_code
                            }
                            SetApp_Btn("Done")
                            SetTransCation(Data)
                            DBsavePackBuy(Data, PlanShowTable)
                        });
                        }}
                        onError={(err) => {
                        SetApp_Btn("Try Again")
                        toastAlert("error", err);
                        }}

                    />
                    </PayPalScriptProvider>
                </div>
                </Modal.Body>

            </Modal>

        </div>
    )
}

export default PayModal